import { useQuery } from 'react-query'

// Libs
import { fetchDeliveryMethodList } from '@/api/fetchDeliveryMethodList'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// Types
interface IParams {
  merchantId: number
}

export const useDeliveryMethod = (params: IParams) => {
  const { data, isSuccess, isFetched } = useQuery([QUERY_KEY.FETCH_MERCHANTS_INFO, { params }], () => fetchDeliveryMethodList({ ...params }), {
    enabled: !!params?.merchantId,
  })

  return { deliveryMethodData: data, isDeliveryMethodFetched: isFetched, isDeliveryMethodSuccess: isSuccess }
}
